// extracted by mini-css-extract-plugin
export var hidden = "layout-module--hidden--1lmWx";
export var container = "layout-module--container--YM7Lx";
export var siteTitle = "layout-module--site-title--16llq";
export var siteIcon = "layout-module--site-icon--13SfV";
export var navLinks = "layout-module--nav-links--1VlO2";
export var navLinkItem = "layout-module--nav-link-item--31U8T";